import { defineStore } from "pinia";

let id = 0;
export function getUniqueId(): number {
  return id++;
}

export enum AlertTypes {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  NEUTRAL = "neutral",
  INFO = "info",
  SUCCESS = "success",
  CAUTION = "caution",
  WARNING = "warning",
  DANGER = "danger",
}

interface IAlertLike {
  _id: number;
  delay?: number; // Time (ms) to delay showing the alert.
  autoDismiss?: number; // Time (ms) before alert is auto dismissed. Pass `0` to persist alert.
  message: string;
  type?: AlertTypes;
}

export interface INotification extends IAlertLike {
  title: string;
}

export interface IToast extends IAlertLike {}

export const useWidgetStore = defineStore("WidgetStore", {
  // State
  state: () => {
    return {
      count: 0,
      toasts: [] as IToast[],
      notifications: [] as INotification[],
    };
  },

  // Actions
  actions: {
    incrementCount() {
      this.count++;
    },
    addNotification(
      notification: Pick<
        INotification,
        "autoDismiss" | "delay" | "message" | "title" | "type"
      >
    ) {
      setTimeout(() => {
        this.notifications.push({
          _id: getUniqueId(),
          autoDismiss: 5000,
          type: AlertTypes.NEUTRAL,
          ...notification,
        });
      }, notification.delay ?? 0);
    },
    binNotification(notif: INotification) {
      const nI = this.notifications.findIndex(({ _id }) => _id === notif._id);
      if (nI > -1) this.notifications.splice(nI, 1);
    },
    addToast(
      toast: Pick<IToast, "autoDismiss" | "delay" | "message" | "type">
    ) {
      setTimeout(() => {
        this.toasts.push({
          _id: getUniqueId(),
          autoDismiss: 2500,
          type: AlertTypes.NEUTRAL,
          ...toast,
        });
      }, toast.delay ?? 0);
    },
    binToast(toast: IToast) {
      const tI = this.toasts.findIndex(({ _id }) => _id === toast._id);
      if (tI > -1) this.toasts.splice(tI, 1);
    },
  },
});
